// JavaScript Document


function initDropdownSelect(DropdownSelect) {

    const dropdownHolder    = document.querySelector(DropdownSelect);
    const dropdownItems     = dropdownHolder.querySelectorAll('.dropdown-item');
    const btn               = dropdownHolder.querySelector('.btn');
    const btnTitle          = btn.dataset.title;

    const inputDropdown     = dropdownHolder.querySelector('#inputAnliegenPurchasing');

    dropdownItems.forEach(function(dropdownItem){


        dropdownItem.addEventListener('click', function(){

            if (dropdownItem.classList.contains('selected')) {

                dropdownItem.classList.remove('selected');

            } else {

                dropdownItem.classList.add('selected');

            }

            const dropdownItemsSelected  = dropdownHolder.querySelectorAll('.dropdown-item.selected');

            let selectedTitels = "";
            let i = 1;
            const itemsCount = dropdownItemsSelected.length;
            dropdownItemsSelected.forEach(function(dropdownItemSelected){

                selectedTitels += dropdownItemSelected.getAttribute("title");

                if (i < itemsCount) {
                    selectedTitels += ', ';
                }

                i++;
            });

            if (selectedTitels) {
                btn.innerHTML = selectedTitels;
            } else {
                btn.innerHTML = btnTitle;
            }
            
            inputDropdown.value =  selectedTitels;


        });
    });

    function setVal(termId) {



    }

    function resetDropdown() {




    }
 
    return {

    };

}
